// extracted by mini-css-extract-plugin
export default {"container":"ovGaEY","petName":"QAHsxw","activePetName":"e9cUda","inactivePetName":"sE1TAI"};